import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Results } from '@local/client-contracts';

@Component({
  selector: 'result-rich-text-emoji',
  templateUrl: './result-rich-text-emoji.component.html',
  styleUrls: ['./result-rich-text-emoji.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultRichTextEmojiComponent {
  private _model: Results.RichTextEmoji;
  private readonly skinTone: string = '-1f3f';
  private readonly dicConvertor = {
    1: 'a',
    2: 'b',
    3: 'c',
    4: 'd',
    5: 'e',
    6: 'f',
  };

  unicode: string = '';

  @Input() set model(val: Results.RichTextEmoji) {
    this._model = val;
    this.unicode = val.unicode;
    if (this.model.skinTone) {
      this.unicode = this.removeSkinTone();
      this.cdr.markForCheck();
    }
  }

  get model(): Results.RichTextEmoji {
    return this._model;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  private removeSkinTone(): string {
    return this.model.unicode.replace(`${this.skinTone}${this.dicConvertor[this._model.skinTone]}`, '');
  }
}
